'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GeoLocation = undefined;
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reducer = require('../reducer');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var debugStyles = {
  position: 'absolute',
  left: 0,
  top: 0,
  border: '1px solid #ccc',
  padding: '5px',
  margin: '5px',
  zIndex: 1000
};
var GeoLocation = function (_Component) {
  _inherits(GeoLocation, _Component);
  function GeoLocation() {
    _classCallCheck(this, GeoLocation);
    var _this = _possibleConstructorReturn(this, (GeoLocation.__proto__ || Object.getPrototypeOf(GeoLocation)).call(this));
    _this.saveLocation = function (position) {
      var _position$coords = position.coords,
        latitude = _position$coords.latitude,
        longitude = _position$coords.longitude,
        altitude = _position$coords.altitude,
        accuracy = _position$coords.accuracy,
        altitudeAccuracy = _position$coords.altitudeAccuracy,
        heading = _position$coords.heading,
        speed = _position$coords.speed;
      var options = {
        latitude: latitude,
        longitude: longitude,
        altitude: altitude,
        accuracy: accuracy,
        altitudeAccuracy: altitudeAccuracy,
        heading: heading,
        speed: speed
      };
      _this.savePositionToLocalStorage(options);
      _this.props.saveGeolocation(options, _this.props.googleAPIKey);
    };
    _this.handleGeoLocationError = function (error) {
      switch (error.code) {
        // permission expired
        case 3:
          {
            // Quick fallback when no suitable cached position exists.
            navigator.geolocation.getCurrentPosition(_this.saveLocation, function (err) {
              return err.code === 1 ? _this.handleGeoLocationError(err) : _this.props.geolocationError(err);
            });
            break;
          }

        // permission denied
        case 1:
          {
            // Quick fallback when no suitable cached position exists.
            _this.getLocationFallback(error);
            break;
          }
        default:
          {
            _this.props.geolocationError(error);
          }
      }
    };
    _this.getLocationFallback = function (err) {
      fetch('//freegeoip.net/json/?callback=?').then(function (res) {
        return res.text();
      }).then(function (text) {
        var match = text.match(/\?\((.*)\);/);
        if (!match) throw new Error('invalid JSONP response');
        var _JSON$parse = JSON.parse(match[1]),
          latitude = _JSON$parse.latitude,
          longitude = _JSON$parse.longitude;
        _this.savePositionToLocalStorage({
          latitude: latitude,
          longitude: longitude
        });
        _this.props.saveGeolocation({
          latitude: latitude,
          longitude: longitude
        }, _this.props.googleAPIKey);
      }).catch(function () {
        _this.props.geolocationError(err);
        console.log('freegeoip error', err);
      });
    };
    _this.getLocation = function () {
      if (!_this.state.geoLocationEnabled) return;
      navigator.geolocation.getCurrentPosition(_this.saveLocation, _this.handleGeoLocationError, _this.geoOptions);
    };
    _this.watchGeoLocation = function () {
      if (!_this.state.geoLocationEnabled) return;
      navigator.geolocation.watchPosition(_this.saveLocation, _this.handleGeoLocationError, _this.geoOptions);
    };
    _this.savePositionToLocalStorage = function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      localStorage.setItem('react-redux-geolocation-position', JSON.stringify(options));
    };
    _this.getPositionFromLocalStorage = function () {
      try {
        var position = JSON.parse(localStorage.getItem('react-redux-geolocation-position'));
        _this.props.saveGeolocation(position, _this.props.googleAPIKey);
      } catch (err) {
        console.log('invalid position object in localStorage');
      }
    };
    _this.state = {
      geoLocationEnabled: 'geolocation' in navigator
    };
    return _this;
  }
  _createClass(GeoLocation, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.getPositionFromLocalStorage();
      this.props.watch ? this.watchGeoLocation() : this.getLocation();
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.debug) return null;
      return _react2.default.createElement('div', {
        style: debugStyles
      }, _react2.default.createElement('h4', null, 'Props'), _react2.default.createElement('pre', null, JSON.stringify(this.props, null, 2)), _react2.default.createElement('h4', null, 'State'), _react2.default.createElement('pre', null, JSON.stringify(this.state, null, 2)));
    }
  }, {
    key: 'geoOptions',
    get: function get() {
      var options = {
        enableHighAccuracy: this.props.enableHighAccuracy,
        maximumAge: this.props.maximumAge,
        timeout: this.props.timeout
      };
      var validation = {
        enableHighAccuracy: function enableHighAccuracy(prop) {
          return typeof prop === 'boolean';
        },
        maximumAge: function maximumAge(prop) {
          return typeof prop === 'number';
        },
        timeout: function timeout(prop) {
          return typeof prop === 'number';
        }
      };

      // only pass values with valid type
      return Object.keys(options).reduce(function (acc, key) {
        var option = options[key];
        var validationFn = validation[key];
        return validationFn(option) ? _extends({}, acc, _defineProperty({}, key, option)) : _extends({}, acc);
      }, {});
    }

    // get cached location

    // fallback makes api call to 3rd party service
    // on success save to LS and save lat,long in reducer.
  }]);
  return GeoLocation;
}(_react.Component);
GeoLocation.propTypes = {
  debug: _propTypes2.default.bool,
  watch: _propTypes2.default.bool,
  timeout: _propTypes2.default.number,
  maximumAge: _propTypes2.default.number,
  enableHighAccuracy: _propTypes2.default.bool,
  googleAPIKey: _propTypes2.default.string
};
GeoLocation.defaultProps = {
  debug: false,
  watch: false,
  // geoOptions defaults to a cached position
  // if it fails it tries to get a real position
  timeout: 0,
  maximumAge: Infinity,
  enableHighAccuracy: false,
  googleAPIKey: ''
};
exports.GeoLocation = GeoLocation;
exports.default = (0, _reactRedux.connect)(_reducer.selector, {
  saveGeolocation: _reducer.actions.saveGeolocation,
  geolocationError: _reducer.actions.geolocationError
})(GeoLocation);